module.exports = __webpack_public_path__ + "9addfcf4b2fd04c83eaa48bb3f424d40.png";